import React, { useEffect } from 'react';
import { Box } from '@wix/design-system';
import { useResponsiveComponents } from '../../hooks/useResponsiveComponents';
import { useBiLogger } from '../../providers/BiLoggerProvider';
import { useUnknownChargeContext } from '../../providers/UnknownChargeProvider';
import { Faq } from '../Faq/Faq';
import { Notification } from '../Notification/Notification';

export const PageLayout: React.FC<{ title: string; subtitle: string }> = ({
  children,
  title,
  subtitle,
}) => {
  const [Responsive] = useResponsiveComponents();
  const {
    pageErrors: { hasError, message },
  } = useUnknownChargeContext();
  const { biLogger } = useBiLogger();

  useEffect(() => {
    biLogger.chargeLocatorLoad();
  }, []);
  return (
    <>
      <Notification show={hasError} message={message} />
      <Box direction="vertical" paddingBottom="SP8" width="100%">
        <Responsive.TitleAndSubTitle title={title} subtitle={subtitle} />
        <>{children}</>
      </Box>
      <Box direction="vertical" padding="SP8 0" backgroundColor="D70">
        <Faq />
      </Box>
    </>
  );
};
